import dayjs from "dayjs";
import type { Agreement } from "../api/partners";

export const isAgreementExpired = ({ validUntil }: Pick<Agreement, "validUntil">) =>
  Boolean(validUntil) && dayjs(validUntil).isBefore(dayjs(), "day");
